; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('businessDataItem', businessDataItem)

  function businessDataItem () {
    return {
      restrict: 'E',
      scope: {
        page: '@',
        data: '<',
        index: '@',
        downloadCallback: '&',
        linkedTemplate: '@',
        originModalReference: '<'
      },
      templateUrl: '/arts/directives/business-data-item/business-data-item-directive.html?$$REVISION$$',
      controller: 'businessDataItemController'
    }
  }
})()
